module.exports = __webpack_public_path__ + "static/media/lock.24facd55.svg";